import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-trending-hashtag',
  standalone: true,
  imports: [CommonModule, CommonProfileInfoComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './trending-hashtag.component.html',
  styleUrls: ['./trending-hashtag.component.scss']
})
export class TrendingHashtagComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'Trending # Hashtags ';

  headerTitle: string = 'Trending Hashtags';
  user: any = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  constructor(private a_route: ActivatedRoute) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if(res.menu!=null &&res.menu!=undefined){
       this.headerTitle=res.menu;
      }
   })
  }

}
